import { render, staticRenderFns } from "./editrole.vue?vue&type=template&id=45799774&scoped=true"
import script from "./editrole.vue?vue&type=script&lang=js"
export * from "./editrole.vue?vue&type=script&lang=js"
import style0 from "./editrole.vue?vue&type=style&index=0&id=45799774&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45799774",
  null
  
)

export default component.exports